import CellValue from '@app/shared/components/cell-value/CellValue';
import { amountRules } from '@app/shared/components/cell-value/CellValueConfigurations';
import { TransactionType } from '@app/shared/models/contracts/enums/shared-enums';
import { OpmFirstLastWaterfallDictionaryDto } from '@app/shared/models/contracts/opm-calculation-results-dto';
import classNames from 'classnames';
import styles from '@app/modules/projects/outputs/opm-summary-waterfall/opm-summary-waterfall-erf.module.scss';
import { getTransactionValues, simulationSectionsDefinition } from '../../helper/FirstLastHelpers';

interface InstrumentTransactionRowProps {
  opmWaterfall: OpmFirstLastWaterfallDictionaryDto;
  selectedYear: string;
  selectedInstrument: string;
  transactionType: TransactionType;
  rowKeyPrefix: string;
}

const InstrumentTransactionRow: React.FC<InstrumentTransactionRowProps> = ({
  opmWaterfall,
  selectedYear,
  selectedInstrument,
  transactionType,
  rowKeyPrefix,
}: InstrumentTransactionRowProps) => {
  const simulationKeys = simulationSectionsDefinition.map((section) =>
    Object.keys(opmWaterfall[selectedYear][section])
  );

  const transactionValues = getTransactionValues(
    opmWaterfall,
    selectedYear,
    selectedInstrument,
    transactionType,
    'amount'
  );

  const allTransactions = Object.keys(transactionValues);
  if (allTransactions.length === 0) {
    return null;
  }

  return (
    <>
      {allTransactions.map((transactionName, rowIdx) => (
        <tr key={`${rowKeyPrefix}-row-${rowIdx}`}>
          <td
            className={classNames(styles['border-right'])}
            data-testid={`${rowKeyPrefix}-narrative-title-${rowIdx}`}>
            {transactionName}
          </td>
          {simulationSectionsDefinition.map((section, outerIdx) =>
            Object.keys(opmWaterfall[selectedYear][section]).map((simKey, innerIdx) => (
              <td
                key={`${section}-${simKey}`}
                className={classNames({
                  [styles['border-right']]:
                    outerIdx === 0 && innerIdx + 1 === simulationKeys[0].length,
                })}
                data-testid={`${rowKeyPrefix}-amount-simulation-${section}-${simKey}-${rowIdx}`}>
                <CellValue
                  value={transactionValues[transactionName][section]?.[simKey] ?? null}
                  {...amountRules}
                />
              </td>
            ))
          )}
        </tr>
      ))}
    </>
  );
};

export default InstrumentTransactionRow;
